import { App } from '@microsoft/portal-app/lib/App/App';
import { IRootAppSuiteState } from '@microsoft/portal-app/lib/AppSuite';
import { AppKeys } from '@microsoft/portal-app/lib/environment';
import { getSuiteAppProps } from '@microsoft/portal-app/lib/MyStar';
import { ISuiteAppProps } from '@uifabric/portal-ux/lib/components/StandardAppBar/ISuiteAppProps';
import { translate } from 'react-i18next';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IRootAccountState } from '../../Account/models';
import { IAppActions, IAppMappedProps, IConnectedAppProps } from './App.types';

/**
 * Maps the external (i.e. own) props and the state to the properties of the App control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IAppProps) for the App control
 */
export const mapStateToConnectedAppProps = (
  state: IRootAccountState & IRootAppSuiteState,
  ownProps: IConnectedAppProps & { onShowInProductFeedback?: VoidFunction },
): IAppMappedProps => {
  const { t } = ownProps;

  const enabledAppState = state.appSuite && state.appSuite.enabledApps;
  let enabledApps: ISuiteAppProps[] | undefined = undefined;
  if (enabledAppState !== undefined) {
    enabledApps = getSuiteAppProps(AppKeys.account, enabledAppState.value, t!);
  }

  return {
    ...ownProps,
    navRoutes: [{ component: () => null }],
    appBarProps: {
      ...ownProps.appBarProps,
      appSuiteItems: enabledApps,
    },
  };
};
/**
 * Maps the dispatch actions to the props for the App control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IAppProps) for the App control
 */
export const mapDispatchToConnectedAppProps = (_dispatch: Dispatch<{}>): IAppActions => {
  return {};
};

const _ConnectedApp = connect(mapStateToConnectedAppProps, mapDispatchToConnectedAppProps)(App);

/**
 * A redux connected App control.
 * @description Supports translation
 */
export const ConnectedApp = translate('Account')(_ConnectedApp);
